import * as Schema from "effect/Schema";

export const ApplicationReleaseAcceptanceIdentity = Schema.Struct({
  runId: Schema.String,
  applicationIdentity: Schema.String,
  hostStoreRoot: Schema.String,
  releaseTag: Schema.String,
  releaseUrl: Schema.String,
  olderApplicationVersion: Schema.String,
  newerApplicationVersion: Schema.String,
  newerArtifactName: Schema.String,
});

export type ApplicationReleaseAcceptanceIdentity = typeof ApplicationReleaseAcceptanceIdentity.Type;
